/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RequestCompetitorStoreRequest = {
    requestReasonType: RequestCompetitorStoreRequest.requestReasonType;
    requestReasonOther?: string;
    newStoreName?: string;
    preferredDate: string;
};
export namespace RequestCompetitorStoreRequest {
    export enum requestReasonType {
        RENOVATION = 'RENOVATION',
        CLOSED = 'CLOSED',
        RENAME = 'RENAME',
        OTHER = 'OTHER',
    }
}

